import { FormControl, FormLabel } from '@mui/material';
import React, { useId, useState } from 'react';
import { Button } from '../Button';
import MuiModal from '../../mui/MuiModal/MuiModal';
import ProfileImagePicker, {
	ProfileImagePickerValues,
} from '../forms/inputs/ProfileImagePicker';
import styles from './AvatarSelector.module.scss';

export type AvatarSelectorProps = {
	errorText?: string;
	onSelect?: ( file: ProfileImagePickerValues ) => void;
	label: string;
};

export type AvatarSelectorValues = ProfileImagePickerValues;

const AvatarSelector: React.FC<AvatarSelectorProps> = ( {
	onSelect,
	errorText,
	label,
} ) => {
	const [ open, setOpen ] = useState( false );
	const buttonId = useId();
	return (
		<>
			<FormControl error={ !!errorText } className={ styles.container }>
				<FormLabel htmlFor={ buttonId }>{ label }</FormLabel>
				<Button
					id={ buttonId }
					variant='text'
					onClick={ () => setOpen( true ) }
					data-cy='profileImageSelector'
				>
					Add
				</Button>
			</FormControl>
			<MuiModal
				title='Add Profile Picture'
				muiModalProps={ {
					open,
					onClose: () => setOpen( false ),
				} }
			>
				<ProfileImagePicker
					closeModal={ () => setOpen( false ) }
					onSuccess={ ( values: ProfileImagePickerValues ) => {
						onSelect?.( values );
						setOpen( false );
					} }
				/>
			</MuiModal>
		</>
	);
};

export default AvatarSelector;
